import type { ExclusionAreaObservationComment } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export const getComments = async ({
  observationId,
  signal,
}: {
  observationId: string
  signal?: AbortSignal
}): Promise<ExclusionAreaObservationComment[]> => {
  const response = await apiClient.get(
    endpoints.v2.exclusionAreaObservations.comments(observationId),
    { signal },
  )
  return unwrapCollection<ExclusionAreaObservationComment>(response)
}
